








import { Prop, Component, Vue } from 'vue-property-decorator';
import { YoutubeService, YoutubeServiceEvents } from '../services/YoutubeService';

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window { YT: any; }
}

@Component
export default class YoutubePlayerComponent extends Vue {
    @Prop() id!: string;

    public image: string = '';
    public player!: any;
    public timeout!: number;

    mounted() {
        if(YoutubeService.apiReady) {
            this.initVideo();
        } 

        YoutubeServiceEvents.$on('apiReady', () => {
            this.initVideo();
        });

        YoutubeService.load();  
    }

    public initVideo() {
        this.player = new window.YT.Player(this.$refs.playerPlaceholder, {
            height: '390',
            width: '640',
            videoId: this.id,
            playerVars: {
                disablekb: 1
            },
            events: {
                'onStateChange': this.onStateChange
            }
        });
    }


    public onStateChange(event: any) {
        clearTimeout(this.timeout);

        /** Playing & Buffering */
        if (event.data === 1 || event.data === 3) {
            window.dispatchEvent( new Event('videoIsPlaying') );
        }

        /** Ended & Paused */
        if (event.data === 0 || event.data === 2) {
            window.dispatchEvent( new Event('videoIsStopped') );
        }
    }
}
